<div class="form-field checkbox" [class.disabled]="disabled || readonly">
	<div class="checkbox-default">
		<input type="checkbox" [formControl]="formControl" />
		<label>{{ label }}</label>
	</div>
</div>
